<template>
    <section id="ready-to-be-delivered">

        <div class="table-delivery-container">
            <div class="label-row">
                <label
                    for="table-ready-for-delivery"
                    class="label-heading"
                >
                    Ready for Delivery
                </label>
                <button
                    role="button"
                    type="button"
                    class="button is-primary button-ready-to-deliver"
                    title="Prepare to deliver checked items"
                    :disabled="!hasCheckedDeliveryItems"
                    @click="prepareToDeliver()"
                >
                    <MaterialDesignIcon
                        className="transfer-right"
                        hasRightMargin
                    />
                    Ready to Deliver
                </button>
            </div>
            <b-table
                id="table-ready-for-delivery"
                :data="outboundDeliveryItemInfo.list"
                :columns="outboundDeliveryItemInfo.tableColumns"
                :checkedRows.sync="models.checkedDeliveryItems"
                defaultSort="destinationLocatorDescription"
                checkable
                hoverable
                striped
            >
            </b-table>
        </div>

    </section>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

// Api
import DeliveryApi from '@/api/DeliveryApi';

// Utils
import ValidationUtil from '@/utils/ValidationUtil';

// Components
import MaterialDesignIcon from '@/components/base/MaterialDesignIcon';

export default {
    name: 'ReadyToBeDelivered',
    components: {
        MaterialDesignIcon,
    },
    data() {
        return {
            /** @type { Object } */
            models: {
                /** @type { Array } */
                checkedDeliveryItems: [],
            },

            /** @type { Object } */
            outboundDeliveryItemInfo: {
                /** @type { Array } */
                list: [],
                /** @type { Boolean } */
                inFlight: false,
                /** @type { Array } */
                tableColumns: [
                    {
                        field: 'mailTypeFriendly',
                        label: 'Type',
                        sortable: true,
                    },
                    {
                        field: 'customerFullName',
                        label: 'Recipient',
                        sortable: true,
                    },
                    {
                        field: 'destinationLocatorDescription',
                        label: 'Destination',
                        sortable: true,
                    },
                    {
                        field: 'sender',
                        label: 'Sender',
                        sortable: true,
                    },
                    {
                        field: 'mailCarrierFriendly',
                        label: 'Carrier',
                        sortable: true,
                    },
                ],
            },

            /** @type { Object } */
            picklistInfo: {
                inFlight: false,
                acceptedItems: [],
                problemItems: [],
            },
        };
    },
    computed: {
        ...mapState( {
            jwtToken: ( state ) => state.User.jwtToken,
            userAccountId: ( state ) => state.User.accountId,
        } ),
        ...mapGetters( {
            websiteId: 'Website/id',
        } ),
        /** @returns { Number } */
        countCheckedDeliveryItems() {
            return this.models.checkedDeliveryItems.length;
        },
        /** @returns { Boolean } */
        hasCheckedDeliveryItems() {
            return this.countCheckedDeliveryItems > 0;
        },
    },
    mounted() {
        this.getOutboundDeliveryItems();
    },
    methods: {
        async getOutboundDeliveryItems() {
            this.outboundDeliveryItemInfo.inFlight = true;
            try {
                const { data } = await DeliveryApi.getOutboundItems( {
                    jwtToken: this.jwtToken,
                    websiteId: this.websiteId,
                    userAccountId: this.userAccountId,
                } );

                this.outboundDeliveryItemInfo.list = ValidationUtil.arrayHasItems( data.mailSearchListDTO )
                    ? data.mailSearchListDTO
                    : [];

                if ( data.message.toLowerCase().includes( 'no outbound' ) ) {
                    await this.$store.dispatch( 'snackbar', {
                        message: data.message,
                        type: 'success',
                        duration: 5000,
                    }, { root: true } );
                }
            } catch ( error ) {
                await this.$store.dispatch( 'snackbar', {
                    message: 'Error: Unable to get outbound items',
                    type: 'error',
                    duration: 5000,
                }, { root: true } );
            } finally {
                this.outboundDeliveryItemInfo.inFlight = false;
            }
        },
        async generatePickList() {
            this.picklistInfo.inFlight = true;
            try {
                const { data } = await DeliveryApi.generatePicklist( {
                    jwtToken: this.jwtToken,
                    websiteId: this.websiteId,
                    userAccountId: this.userAccountId,
                    idList: this.models.checkedDeliveryItems.map( ( item ) => item.id ),
                } );

                this.picklistInfo.acceptedItems = data.deliveryPicklistMailItems;
                this.picklistInfo.problemItems = data.rejectedMailItems;
            } catch ( error ) {
                await this.$store.dispatch( 'snackbar', {
                    message: 'Error generating delivery picklist',
                    type: 'error',
                    duration: 5000,
                }, { root: true } );
            } finally {
                this.picklistInfo.inFlight = false;
            }
        },
        async prepareToDeliver() {
            await this.generatePickList();
        },
    },
};
</script>

<style scoped lang="scss">

.label-heading {
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: underline;
}

.label-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.table-delivery-container {
    display: flex;
    flex-flow: column nowrap;
}

#table-ready-for-delivery {
    box-shadow: $variables-material-shadow-1;
}

@include mixins-above(tablet) {
    //
}
</style>
